module.exports = __webpack_public_path__ + "img/250.c81d3e69.jpg";